import { render, staticRenderFns } from "./compbase.vue?vue&type=template&id=a138b578"
import script from "./compbase.vue?vue&type=script&lang=js"
export * from "./compbase.vue?vue&type=script&lang=js"
import style0 from "./compbase.vue?vue&type=style&index=0&id=a138b578&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports